import { render, staticRenderFns } from "./SpotSummary.vue?vue&type=template&id=4ba0d289"
import script from "./SpotSummary.vue?vue&type=script&lang=js"
export * from "./SpotSummary.vue?vue&type=script&lang=js"
import style0 from "./SpotSummary.vue?vue&type=style&index=0&id=4ba0d289&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports